export default {"src":"/_next/static/media/comprehensivePlanBackground.3ca0db0e.svg","height":165,"width":1116,"blurWidth":0,"blurHeight":0};